import Reveal, { SectionLabel } from "./Reveal"

const steps = [
  {
    title: "Conversa",
    text: "Entendemos o seu negócio, o público e o objetivo do projeto — sem jargão técnico.",
  },
  {
    title: "Proposta",
    text: "Você recebe escopo, prazo e investimento claros antes de qualquer linha de código.",
  },
  {
    title: "Desenvolvimento",
    text: "Design e código modernos, com entregas parciais para você acompanhar cada etapa.",
  },
  {
    title: "Lançamento & suporte",
    text: "Colocamos no ar e seguimos por perto com manutenção, melhorias e suporte técnico.",
  },
]

const Processo = () => (
  <section className="k-section k-process" id="processo">
    <div className="k-container">
      <div className="k-process__head">
        <Reveal>
          <SectionLabel index="01">Como trabalhamos</SectionLabel>
          <h2 className="k-h2">
            Tecnologia com <em>cuidado de ateliê</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.1} as="p" className="k-process__intro">
          A KJR Desenvolvimento transforma ideias em produtos digitais que funcionam de verdade. Cada projeto é
          pensado sob medida, com processo transparente e um time que fala a sua língua.
        </Reveal>
      </div>

      <ol className="k-process__steps">
        {steps.map((s, i) => (
          <Reveal as="li" key={s.title} delay={i * 0.08} className="k-step">
            <span className="k-step__num">0{i + 1}</span>
            <svg className="k-step__hex" viewBox="0 0 100 116" aria-hidden>
              <polygon points="50,2 98,30 98,86 50,114 2,86 2,30" />
            </svg>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
)

export default Processo
